import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KillScreen = () => (
  <div
    data-testid="site-killed-screen"
    style={{
      position: "fixed",
      inset: 0,
      background: "#000",
      color: "#fff",
      display: "grid",
      placeItems: "center",
      fontFamily: '"Bebas Neue", sans-serif',
      fontSize: "clamp(40px, 8vw, 120px)",
      letterSpacing: "0.05em",
      zIndex: 99999,
    }}
  >
    SITE SHUT DOWN.
  </div>
);

const KillGate = ({ children }) => {
  const [state, setState] = useState({ loading: true, killed: false });

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/site/status`)
      .then((r) => {
        if (!cancelled) setState({ loading: false, killed: !!r.data?.killed });
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, killed: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.loading) {
    return (
      <div style={{ position: "fixed", inset: 0, background: "#0a0a0b" }} />
    );
  }
  if (state.killed) return <KillScreen />;
  return children;
};

export default KillGate;
